function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20pt",
    height: "20pt",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#00368E",
      fillOpacity: 1
    },
    d: "M 10.417969 2.5 L 7.5 2.5 L 7.5 14.164062 L 15.832031 14.167969 L 15.832031 7.917969 L 12.085938 7.917969 C 11.164062 7.917969 10.417969 7.171875 10.417969 6.253906 Z M 12.085938 6.25 L 15.535156 6.25 L 12.082031 2.746094 C 12.082031 4.089844 12.085938 6.25 12.085938 6.25 Z M 14.167969 18.320312 C 14.167969 18.777344 13.792969 19.152344 13.335938 19.152344 L 3.328125 19.164062 C 2.871094 19.167969 2.5 18.796875 2.5 18.332031 L 2.5 5 C 2.5 4.539062 2.871094 4.167969 3.335938 4.167969 L 5.832031 4.167969 L 5.832031 1.667969 C 5.832031 1.207031 6.203125 0.832031 6.667969 0.832031 L 12.113281 0.832031 C 12.34375 0.832031 12.664062 0.96875 12.828125 1.132812 L 17.203125 5.535156 C 17.367188 5.699219 17.5 6.023438 17.5 6.25 L 17.5 14.984375 C 17.5 15.445312 17.125 15.816406 16.671875 15.816406 L 14.167969 15.820312 Z M 6.664062 15.832031 C 6.203125 15.832031 5.832031 15.460938 5.832031 15 L 5.832031 5.832031 L 4.175781 5.832031 L 4.167969 17.5 L 12.5 17.5 L 12.5 15.824219 Z M 6.664062 15.832031 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceActive);
export default __webpack_public_path__ + "static/media/invoice_active.d9db223cbe892f4b98d6b7b39453bc8b.svg";
export { ForwardRef as ReactComponent };